import { Col, Row } from '@cuemath/comps';
import React from 'react';
import { MAPPING_FILTERS_TYPES } from 'constants/auto-mapping';
import { Dropdown, Separator } from '@cuemath/web-comps';
import LAYOUT from 'constants/layout';
import styled from 'styled-components';
import useLogic from './MappingFilters.logic';

const FilterItem = styled(Col)`
  max-height: 50px;
  padding-left: 0;
  margin-bottom: 8px;
`;

const filterMapper = {
  [MAPPING_FILTERS_TYPES.DROPDOWN]: ({ label, options, code, value, handleChange }) => (
    <Dropdown
      onChange={value => handleChange({ key: code, value })}
      label={label}
      value={value}
      options={options?.map(option => ({ ...option, id: option?.value }))}
      optionsWidth="320px"
      width="320px"
      height="auto"
      type="primary"
    />
  ),
};

const MappingFilters = ({ handleChange, filters }) => {
  const { mappingFilters } = useLogic({ filters });
  const { GUTTER } = LAYOUT;
  return (
    <>
      <Row alignItems="center">
        {mappingFilters?.map(({ type, label, code, options }) => (
          <FilterItem key={code}>
            {filterMapper?.[type]?.({
              label,
              options,
              code,
              value: filters?.[code] ?? '',
              handleChange,
            })}
          </FilterItem>
        ))}
      </Row>
      <Separator height={GUTTER * 1} />
    </>
  );
};

export default MappingFilters;
